(() => {
  let loading = false;
  const moreQuestionForm = document.querySelector('.moreQuestion__form');
  const messageElement = document.querySelector('.form__message');

  if (moreQuestionForm) {
    const team = moreQuestionForm.querySelector('#team');

    moreQuestionForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const input = moreQuestionForm.querySelector('input[type="radio"]:checked');
      const mission = moreQuestionForm.querySelector('#mission');
      const missionValue = mission.value;
      const teamValue = checkInput(team)
      let inputValue = false;
      if (input) {
        inputValue = input.value;
      }
      else {
        messageElement.innerHTML = '<span class="error">Nie wybrano odpowiedzi</span>';
        return;
      }
      messageElement.innerHTML = '';

      if (teamValue && inputValue && !loading) {
        loading = true;

        const data = new FormData();
        data.append('team', teamValue);
        data.append('answer', inputValue);
        data.append('mission', missionValue);
        data.append('action', 'msm_mission');

        fetch(my_ajax_object.ajaxurl, {
          method: 'post',
          body: data,
        })
          .then(function (response) {
            return response.json();
          })
          .then(function (json) {
            messageElement.innerHTML = json.msg;
            loading = false;

          });

      }
    })
    if (team) {
      team.addEventListener('change', function (e) {
        checkInput(team)
      })
    }
  }


  function checkInput(element) {
    const errorElement = element.parentNode.querySelector('.form__error');
    if (!element.value) {
      errorElement.style.display = 'block';
      return false;
    }
    else {
      errorElement.style.display = 'none';
      return element.value;
    }
  }

})()